import { useState } from 'react';

/**
 * Detect double taps
 * @param callback function to be called on double tap
 * @param delay detection time between taps
 * @returns 
 */
const useDoubleTap = (callback: Function, delay: number = 300) => {
  const [tap, setTap] = useState(0);

  const handleTap = () => {
    const now = Date.now();
    const delta = now - tap;

    if (delta < delay && delta > 0) {
      callback();
    }
    setTap(now);
  };

  return handleTap;
};

export default useDoubleTap;